import styled from 'styled-components'

export const ModalContent = styled.div`
  padding: 24px 0;
  line-height: 1.6;
`

export const MessageText = styled.p`
  font-size: 16px;
  color: #333;
  margin-bottom: 24px;
`

export const RequirementsList = styled.ul`
  margin: 16px 0 24px 0;
  padding-left: 20px;
  
  li {
    margin-bottom: 8px;
    line-height: 1.5;
    color: #555;
  }
`

export const ExternalLinkSection = styled.div`
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 6px;
  margin: 16px 0;
`

export const ExternalLinkText = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0 0 8px 0;
  word-break: break-all;
`

export const ExternalUrl = styled.a`
  background-color: #e6f7ff;
  padding: 4px 8px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 13px;
  word-break: break-all;
`

export const IressStatusSection = styled.div`
  background-color: #fff7e6;
  border: 1px solid #ffd591;
  padding: 16px;
  border-radius: 6px;
  margin: 16px 0;
`

export const IressStatusText = styled.p`
  font-size: 14px;
  color: #ad6800;
  margin: 0;
  line-height: 1.5;
`

export const SupportText = styled.p`
  font-size: 12px;
  color: #999;
  margin-top: 24px;
  text-align: center;
  
  a {
    color: #1890ff;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`

export const ActionButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 24px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    
    .ant-btn {
      width: 100%;
    }
  }
`